const dateMonthesShort = Object.freeze({ 1: 'Янв', 2: 'Фев', 3: 'Мар', 4: 'Апр', 5: 'Май', 6: 'Июн', 7: 'Июл', 8: 'Авг', 9: 'Сен', 10: 'Окт', 11: 'Ноя', 12: 'Дек' })

const activityStatuses = {
  draft: ['grey', 'Черновик'],
  pending: ['orange', 'Согласование'],
  confirmed: ['green', 'Подтверждена'],
  completed: ['green darken-2', 'Завершена'],
  canceled: ['red darken-4', 'Отменена'],
}

const microunitStatuses = [
  { value: 'unaccepted', text: 'Не утвержден', icon: '❓' },
  { value: 'accepted', text: 'Утвержден', icon: '✔' },
  { value: 'producing', text: 'Изготавливается', icon: '✍' },
  { value: 'pending', text: 'Ожидает', icon: '⌛' },
  { value: 'placing', text: 'Публикуется', icon: '⇧' },
  { value: 'placed', text: 'Размещен', icon: '🔥' },
  { value: 'placed_nd', text: 'Размещен НД', icon: '📛' },
  { value: 'displacing', text: 'Удаляется', icon: '⇩' },
  { value: 'completed', text: 'Завершен', icon: '👌' }
]

const mailingStatuses = [
  { value: 'draft', text: 'Черновик', color: '#C0C0C0' },
  { value: 'planned', text: 'Запланирована', color: '#008000' },
  { value: 'sent', text: 'Отправлена', color: '#800080' },
  { value: 'canceled', text: 'Отменена', color: '#20B2AA' },
]

const txStatuses = [
  { text: 'Подтверждена', value: 'approved' },
  { text: 'В ожидании', value: 'pending' },
  { text: 'Отклонена', value: 'declined' },
  { text: 'Устарела', value: 'expired' },
  { text: 'Отменена', value: 'canceled' },
]

const txTypes = [
  { text: 'Приход', value: 'income' },
  { text: 'Инвойс', value: 'invoice' },
  { text: 'Возврат', value: 'refund' },
  { text: 'Расходы', value: 'expenses' },
  { text: 'Зарплата', value: 'wage' },
  { text: 'Дивиденды', value: 'dividends' }
]

const spotsTypes = {
  'banner': {icon: 'mdi-picture-in-picture-top-right', color: 'orange'},
  'shop': {icon: 'mdi-basket-outline', color: 'green'},
  'mailing': {icon: 'mdi-email-send-outline', color: '#af00af'},
  'landing': {icon: 'mdi-cards-variant', color: 'cyan'},
  'social': {icon: 'mdi-account-group-outline', color: 'blue'}
}

const combinedObject = (cols, rows) => rows.map(val => val.reduce((acc, cur, idx) => (acc[cols[idx]] = cur, acc), {}))

export {
  dateMonthesShort,
  combinedObject,
  activityStatuses,
  microunitStatuses,
  mailingStatuses,
  txStatuses,
  txTypes,
  spotsTypes
}
